export default {
  //get all HOMEWORKs
  GET_ALL_SUPERADMIN_HOMEWORKS_REQUEST: "GET_ALL_SUPERADMIN_HOMEWORKS_REQUEST",
  GET_ALL_SUPERADMIN_HOMEWORKS_SUCCESS: "GET_ALL_SUPERADMIN_HOMEWORKS_SUCCESS",
  GET_ALL_SUPERADMIN_HOMEWORKS_FAIL: "GET_ALL_SUPERADMIN_HOMEWORKS_FAIL",

  GET_SUPERADMIN_HOMEWORKS_REQUEST: "GET_SUPERADMIN_HOMEWORKS_REQUEST",
  GET_SUPERADMIN_HOMEWORKS_SUCCESS: "GET_SUPERADMIN_HOMEWORKS_SUCCESS",
  GET_SUPERADMIN_HOMEWORKS_FAIL: "GET_SUPERADMIN_HOMEWORKS_FAIL",

  GET_SUPERADMIN_STUDENT_HOMEWORKS_REQUEST:
    "GET_SUPERADMIN_STUDENT_HOMEWORKS_REQUEST",
  GET_SUPERADMIN_STUDENT_HOMEWORKS_SUCCESS:
    "GET_SUPERADMIN_STUDENT_HOMEWORKS_SUCCESS",
  GET_SUPERADMIN_STUDENT_HOMEWORKS_FAIL:
    "GET_SUPERADMIN_STUDENT_HOMEWORKS_FAIL",

  //edit HOMEWORKs
  EDIT_SUPERADMIN_HOMEWORK_REQUEST: "EDIT_SUPERADMIN_HOMEWORK_REQUEST",
  EDIT_SUPERADMIN_HOMEWORK_SUCCESS: "EDIT_SUPERADMIN_HOMEWORK_SUCCESS",
  EDIT_SUPERADMIN_HOMEWORK_FAIL: "EDIT_SUPERADMIN_HOMEWORK_FAIL",

  //create HOMEWORK
  CREATE_SUPERADMIN_HOMEWORK_REQUEST: "CREATE_SUPERADMIN_HOMEWORK_REQUEST",
  CREATE_SUPERADMIN_HOMEWORK_SUCCESS: "CREATE_SUPERADMIN_HOMEWORK_SUCCESS",
  CREATE_SUPERADMIN_HOMEWORK_FAIL: "CREATE_SUPERADMIN_HOMEWORK_FAIL",

  DELETE_SUPERADMIN_HOMEWORK_REQUEST: "DELETE_SUPERADMIN_HOMEWORK_REQUEST",
  DELETE_SUPERADMIN_HOMEWORK_SUCCESS: "DELETE_SUPERADMIN_HOMEWORK_SUCCESS",
  DELETE_SUPERADMIN_HOMEWORK_FAIL: "DELETE_SUPERADMIN_HOMEWORK_FAIL",

  PUBLISH_SUPERADMIN_HOMEWORK_REQUEST: "PUBLISH_SUPERADMIN_HOMEWORK_REQUEST",
  PUBLISH_SUPERADMIN_HOMEWORK_SUCCESS: "PUBLISH_SUPERADMIN_HOMEWORK_SUCCESS",
  PUBLISH_SUPERADMIN_HOMEWORK_FAIL: "PUBLISH_SUPERADMIN_HOMEWORK_FAIL",

  GET_SUPERADMIN_HOMEWORK_REQUEST: "GET_SUPERADMIN_HOMEWORK_REQUEST",
  GET_SUPERADMIN_HOMEWORK_SUCCESS: "GET_SUPERADMIN_HOMEWORK_SUCCESS",
  GET_SUPERADMIN_HOMEWORK_FAIL: "GET_SUPERADMIN_HOMEWORK_FAIL",

  ENABLE_SUPERADMIN_HOMEWORK_REQUEST: "ENABLE_SUPERADMIN_HOMEWORK_REQUEST",
  ENABLE_SUPERADMIN_HOMEWORK_SUCCESS: "ENABLE_SUPERADMIN_HOMEWORK_SUCCESS",
  ENABLE_SUPERADMIN_HOMEWORK_FAIL: "ENABLE_SUPERADMIN_HOMEWORK_FAIL",

  RESTRICT_SUPERADMIN_HOMEWORK_REQUEST: "RESTRICT_SUPERADMIN_HOMEWORK_REQUEST",
  RESTRICT_SUPERADMIN_HOMEWORK_SUCCESS: "RESTRICT_SUPERADMIN_HOMEWORK_SUCCESS",
  RESTRICT_SUPERADMIN_HOMEWORK_FAIL: "RESTRICT_SUPERADMIN_HOMEWORK_FAIL",
  //loading
  ADD_SUPERADMIN_HOMEWORKS_LOADING: "ADD_SUPERADMIN_HOMEWORKS_LOADING",
  PUBLISH_SUPERADMIN_HOMEWORK_LOADING: "PUBLISH_SUPERADMIN_HOMEWORK_LOADING",
  RESTRICT_SUPERADMIN_HOMEWORK_LOADING: "RESTRICT_SUPERADMIN_HOMEWORK_LOADING",
  ENABLE_SUPERADMIN_HOMEWORK_LOADING: "ENABLE_SUPERADMIN_HOMEWORK_LOADING",
  EDIT_SUPERADMIN_HOMEWORK_QUESTION_REQUEST:
    "EDIT_SUPERADMIN_HOMEWORK_QUESTION_REQUEST",
  EDIT_SUPERADMIN_HOMEWORK_QUESTION_SUCCESS:
    "EDIT_SUPERADMIN_HOMEWORK_QUESTION_SUCCESS",
  EDIT_SUPERADMIN_HOMEWORK_QUESTION_FAIL:
    "EDIT_SUPERADMIN_HOMEWORK_QUESTION_FAIL",
  FILTER_SUPERADMIN_HOMEWORK_REQUEST: "FILTER_SUPERADMIN_HOMEWORK_REQUEST",
  FILTER_SUPERADMIN_HOMEWORK_SUCCESS: "FILTER_SUPERADMIN_HOMEWORK_SUCCESS",
  FILTER_SUPERADMIN_HOMEWORK_FAIL: "FILTER_SUPERADMIN_HOMEWORK_FAIL",

  GET_STUDENT_SUPERADMIN_HOMEWORK_QUIZ_REQUEST:
    "GET_STUDENT_SUPERADMIN_HOMEWORK_QUIZ_REQUEST",
  GET_STUDENT_SUPERADMIN_HOMEWORK_QUIZ_SUCCESS:
    "GET_STUDENT_SUPERADMIN_HOMEWORK_QUIZ_SUCCESS",
  GET_STUDENT_SUPERADMIN_HOMEWORK_QUIZ_FAIL:
    "GET_STUDENT_SUPERADMIN_HOMEWORK_QUIZ_FAIL",
};
